import { loadStripe } from '@stripe/stripe-js/pure';
import { IAction, IBaseAction } from '../useAction';
import useOverlay from '../useOverlay';
import useStripeAttemptPayment from './useStripeAttemptPayment';

export interface IPaymentStripePayAction extends IBaseAction {
  type: 'payment_stripe_pi_pay';

  data: {
    centesimalValue: number;
    currency: string;
    publishableKey: string;
    defaultPaymentMethodId?: string;
    adjustPurchase: {
      revenue: string;
      currency: string;
    };
    relayPayload: object;
    attemptUrl: string;
    // Both are read by stripeCheckoutOverlay but only sent by the checkout flow's
    // StripeParameters, not by the ICBT one - hence optional rather than required.
    paymentMethodTypes?: string[];
    paymentSheetButtonTitle?: string;
  };
}

const usePaymentStripePayAction = () => {
  const overlay = useOverlay();
  const attemptPayment = useStripeAttemptPayment();

  const handlePaymentStripePayAction = async (
    action: IPaymentStripePayAction
  ): Promise<IAction> => {
    const stripe = await loadStripe(action.data.publishableKey);

    return new Promise((resolve, reject) => {
      if (action.data.defaultPaymentMethodId) {
        attemptPayment(stripe, {
          attemptUrl: action.data.attemptUrl,
          relayPayload: action.data.relayPayload,
          paymentMethodId: action.data.defaultPaymentMethodId,
          shouldSaveCard: false,
        })
          .then((flexNavigationAction) => resolve(flexNavigationAction))
          .catch((error) => reject(error));
      } else if (stripe) {
        overlay.presentStripeCheckout({
          stripe,
          stripeParameters: action.data,
          onError: (error) => {
            reject(error);
          },
          onPaymentMethod: (paymentMethod, shouldSaveCard) => {
            attemptPayment(stripe, {
              attemptUrl: action.data.attemptUrl,
              relayPayload: action.data.relayPayload,
              paymentMethodId: paymentMethod.id,
              shouldSaveCard,
            })
              .then((flexNavigationAction) => resolve(flexNavigationAction))
              .catch((error) => reject(error));
          },
        });
      }
    });
  };

  return handlePaymentStripePayAction;
};

export default usePaymentStripePayAction;
